import {
  FiActivity,
  FiBookOpen,
  FiBriefcase,
  FiCalendar,
  FiCheckSquare,
  FiClipboard,
  FiClock,
  FiCreditCard,
  FiDollarSign,
  FiFileText,
  FiHeart,
  FiHome,
  FiInbox,
  FiMessageSquare,
  FiMonitor,
  FiPlay,
  FiUser,
  FiShield,
  FiTrendingUp,
  FiUsers,
} from "react-icons/fi";

export const demoUser = {
  name: "Priya Sharma",
  email: "priya@antrazal.com",
  role: "Product Designer",
};

export const navItems = [
  { id: "dashboard", label: "Dashboard", icon: FiHome },
  { id: "profile", label: "My Profile", icon: FiUser },
  { id: "myForms", label: "My Forms", icon: FiClipboard },
  { id: "events", label: "Events", icon: FiCalendar, highlight: true },
  { id: "ronin", label: "Ronin", icon: FiPlay, href: "/hrm/ronin" },
  { id: "projects", label: "Projects", icon: FiBriefcase },
  { id: "time", label: "Time Entries", icon: FiClock },
  { id: "leave", label: "Leave & Attendance", icon: FiCalendar },
  { id: "payroll", label: "Payroll", icon: FiDollarSign, hint: "August slips ready", shortHint: "Aug ready" },
  { id: "policies", label: "Policies", icon: FiShield },
  { id: "expenses", label: "Expenses", icon: FiCreditCard },
  { id: "assets", label: "Assets", icon: FiMonitor },
  { id: "benefits", label: "Benefits", icon: FiHeart },
  { id: "directory", label: "Directory", icon: FiUsers },
  { id: "performance", label: "Performance", icon: FiTrendingUp },
  { id: "learning", label: "Training", icon: FiBookOpen },
  { id: "requests", label: "Requests", icon: FiMessageSquare },
  { id: "myCases", label: "My Cases", icon: FiInbox, workerOnly: true },
];

export const quickLinks = [
  { id: "profile", label: "My Profile", icon: FiUser, action: "profile" },
  { id: "requestLeave", label: "Request Leave", icon: FiCalendar, action: "leave" },
  { id: "logTime", label: "Log Time", icon: FiClock, action: "time" },
  { id: "addExpense", label: "Add Expense", icon: FiCreditCard, action: "expense" },
  { id: "viewPayslip", label: "View Salary Slip", icon: FiFileText, action: "payslip" },
  { id: "directory", label: "Company Directory", icon: FiUsers, action: "directory" },
];

export const statCards = [
  {
    id: "hours",
    label: "Hours This Week",
    value: "32h 45m",
    detail: "8% vs last week",
    icon: FiClock,
    tone: "blue",
    trend: "up",
  },
  {
    id: "leave",
    label: "Leave Balance",
    value: "18.5 days",
    detail: "Casual Leave",
    icon: FiCalendar,
    tone: "green",
  },
  {
    id: "payroll",
    label: "Upcoming Payroll",
    value: "₹1,24,500",
    detail: "Pay on 31 May 2025",
    icon: FiCreditCard,
    tone: "purple",
  },
  {
    id: "projects",
    label: "Active Projects",
    value: "4",
    detail: "1 new this month",
    icon: FiActivity,
    tone: "amber",
    trend: "up",
  },
  {
    id: "tasks",
    label: "Tasks Due",
    value: "7",
    detail: "Due this week",
    icon: FiCheckSquare,
    tone: "red",
  },
];

export const monthDays = [
  { id: "mon", short: "M", label: "Monday" },
  { id: "tue", short: "T", label: "Tuesday" },
  { id: "wed", short: "W", label: "Wednesday" },
  { id: "thu", short: "Th", label: "Thursday" },
  { id: "fri", short: "F", label: "Friday" },
  { id: "sat", short: "S", label: "Saturday" },
  { id: "sun", short: "Sunday", label: "Sunday" },
];

export const initialMonthTimesheet = [
  {
    id: "week1",
    label: "Week 1",
    range: "01-04 May",
    entries: {
      mon: { hours: "8", project: "HRIS Implementation", description: "Discovery and requirement review", status: "Approved" },
      tue: { hours: "7", project: "HRIS Implementation", description: "Project planning", status: "Submitted" },
      wed: {
        hours: "8",
        project: "Mobile App Redesign",
        description: "Design work",
        status: "Rejected",
        reviewComment: "Please split design and QA time into separate rows before resubmitting.",
      },
      thu: { hours: "8", project: "HRIS Implementation", description: "Stakeholder review" },
      fri: { hours: "6", project: "Employee Portal", description: "Documentation" },
      sat: { hours: "", project: "", description: "" },
      sun: { hours: "", project: "", description: "" },
    },
  },
  {
    id: "week2",
    label: "Week 2",
    range: "05-11 May",
    entries: {
      mon: { hours: "8", project: "Employee Portal", description: "HRM dashboard updates" },
      tue: { hours: "8", project: "Payroll Automation", description: "Payroll workflow checks" },
      wed: { hours: "7", project: "Employee Portal", description: "Policy screens" },
      thu: { hours: "8", project: "Employee Portal", description: "Review fixes" },
      fri: { hours: "8", project: "HRIS Implementation", description: "Release prep" },
      sat: { hours: "", project: "", description: "" },
      sun: { hours: "", project: "", description: "" },
    },
  },
  {
    id: "week3",
    label: "Week 3",
    range: "12-18 May",
    entries: {
      mon: { hours: "8", project: "Employee Portal", description: "Employee profile review" },
      tue: { hours: "7.5", project: "Mobile App Redesign", description: "Mobile layout fixes" },
      wed: { hours: "8", project: "Employee Portal", description: "Request flow testing" },
      thu: { hours: "8", project: "HRIS Implementation", description: "Timesheet planning" },
      fri: { hours: "", project: "", description: "" },
      sat: { hours: "", project: "", description: "" },
      sun: { hours: "", project: "", description: "" },
    },
  },
  {
    id: "week4",
    label: "Week 4",
    range: "19-25 May",
    entries: {
      mon: { hours: "8", project: "HRIS Implementation", description: "Sprint execution" },
      tue: { hours: "7", project: "Mobile App Redesign", description: "UX QA" },
      wed: { hours: "8", project: "Employee Portal", description: "Request record mapping" },
      thu: { hours: "8", project: "Employee Portal", description: "Frontend validation" },
      fri: { hours: "", project: "", description: "" },
      sat: { hours: "", project: "", description: "" },
      sun: { hours: "", project: "", description: "" },
    },
  },
  {
    id: "week5",
    label: "Week 5",
    range: "26-31 May",
    entries: {
      mon: { hours: "", project: "", description: "" },
      tue: { hours: "", project: "", description: "" },
      wed: { hours: "", project: "", description: "" },
      thu: { hours: "", project: "", description: "" },
      fri: { hours: "", project: "", description: "" },
      sat: { hours: "", project: "", description: "" },
      sun: { hours: "", project: "", description: "" },
    },
  },
];

export const timesheetMonths = [
  {
    id: "2025-05",
    label: "May 2025",
    status: "Draft",
    weeks: initialMonthTimesheet,
  },
  {
    id: "2025-04",
    label: "April 2025",
    status: "Approved",
    approvedOn: "02 May 2025",
    weeks: initialMonthTimesheet.map((week, index) => ({
      ...week,
      id: `apr-${week.id}`,
      range: ["01-06 Apr", "07-13 Apr", "14-20 Apr", "21-27 Apr", "28-30 Apr"][index],
      entries: {
        mon: { hours: "8", project: "Employee Portal", task: "Delivery", description: "Approved project work" },
        tue: { hours: "8", project: "Employee Portal", task: "Delivery", description: "Approved project work" },
        wed: { hours: "8", project: "HRIS Implementation", task: "Review", description: "Approved project work" },
        thu: { hours: index === 4 ? "" : "8", project: index === 4 ? "" : "HRIS Implementation", task: index === 4 ? "" : "Build", description: index === 4 ? "" : "Approved project work" },
        fri: { hours: index === 4 ? "" : "7.5", project: index === 4 ? "" : "Mobile App Redesign", task: index === 4 ? "" : "QA", description: index === 4 ? "" : "Approved project work" },
        sat: { hours: "", project: "", task: "", description: "" },
        sun: { hours: "", project: "", task: "", description: "" },
      },
    })),
  },
  {
    id: "2025-03",
    label: "March 2025",
    status: "Draft",
    weeks: initialMonthTimesheet.map((week, index) => ({
      ...week,
      id: `mar-${week.id}`,
      range: ["01-02 Mar", "03-09 Mar", "10-16 Mar", "17-23 Mar", "24-31 Mar"][index],
      entries: {
        mon: { hours: index < 2 ? "8" : "", project: index < 2 ? "Payroll Automation" : "", task: index < 2 ? "Analysis" : "", description: index < 2 ? "Backlog work" : "" },
        tue: { hours: index < 2 ? "7" : "", project: index < 2 ? "Payroll Automation" : "", task: index < 2 ? "Analysis" : "", description: index < 2 ? "Backlog work" : "" },
        wed: { hours: "", project: "", task: "", description: "" },
        thu: { hours: "", project: "", task: "", description: "" },
        fri: { hours: "", project: "", task: "", description: "" },
        sat: { hours: "", project: "", task: "", description: "" },
        sun: { hours: "", project: "", task: "", description: "" },
      },
    })),
  },
];

export const projects = [
  {
    id: "hris",
    name: "HRIS Implementation",
    description: "Core Platform Rollout",
    progress: 75,
    dueDate: "30 Jun 2025",
    manager: "Arjun Mehta",
    managerInitials: "AM",
    projectManagerId: "003-project-manager-1",
    projectManagerName: "Arjun Mehta",
    isProjectManager: false,
  },
  {
    id: "mobile",
    name: "Mobile App Redesign",
    description: "UX/UI Revamp",
    progress: 60,
    dueDate: "15 Jul 2025",
    manager: "Neha Kapoor",
    managerInitials: "NK",
    projectManagerId: "003-project-manager-2",
    projectManagerName: "Neha Kapoor",
    isProjectManager: false,
  },
  {
    id: "payroll",
    name: "Payroll Automation",
    description: "Process Automation",
    progress: 40,
    dueDate: "10 Aug 2025",
    manager: "Ravi Sharma",
    managerInitials: "RS",
    projectManagerId: "003-project-manager-3",
    projectManagerName: "Ravi Sharma",
    isProjectManager: false,
  },
  {
    id: "portal",
    name: "Employee Portal",
    description: "Self-Service Portal",
    progress: 80,
    dueDate: "05 Jun 2025",
    manager: "Arjun Mehta",
    managerInitials: "AM",
    projectManagerId: "003-project-manager-1",
    projectManagerName: "Arjun Mehta",
    isProjectManager: true,
  },
];

export const projectEntities = [
  {
    id: "entity-hris-101",
    key: "HRM-101",
    title: "Employee profile data cleanup",
    projectName: "HRIS Implementation",
    projectId: "hris",
    description: "Review profile, address, document, and payroll identifier mapping before CRM handoff.",
    status: "In Progress",
    priority: "High",
    assignedTo: "Priya Sharma",
    assignedToId: "priya",
    dueDate: "30 Jun 2026",
    recordType: "Task",
    estimatedHours: 24,
    isProjectManager: false,
    comments: [
      {
        id: "comment-101",
        author: "Arjun Mehta",
        body: "Keep the editable and locked fields aligned with HR policy.",
        createdAt: "10 May 2026",
      },
    ],
  },
  {
    id: "entity-hris-102",
    key: "HRM-102",
    title: "Timesheet approval states",
    projectName: "Employee Portal",
    projectId: "portal",
    description: "Make draft, submitted, approved, and rejected time entries clear in the month calendar.",
    status: "Review",
    priority: "Medium",
    assignedTo: "Priya Sharma",
    assignedToId: "priya",
    dueDate: "15 May 2026",
    recordType: "User Story",
    estimatedHours: 16,
    isProjectManager: true,
    comments: [],
  },
  {
    id: "entity-hris-103",
    key: "HRM-103",
    title: "Leave balance validation",
    projectName: "HRIS Implementation",
    projectId: "hris",
    description: "Validate leave requests against available balances and allow LOP when balances are exhausted.",
    status: "Defined",
    priority: "High",
    assignedTo: "Priya Sharma",
    assignedToId: "priya",
    dueDate: "20 May 2026",
    recordType: "Bug",
    estimatedHours: 8,
    isProjectManager: false,
    comments: [],
  },
  {
    id: "entity-hris-104",
    key: "HRM-104",
    title: "Directory employee card polish",
    projectName: "Employee Portal",
    projectId: "portal",
    description: "Use employee profile images, active full-time filtering, and direct email actions.",
    status: "Closed",
    priority: "Low",
    assignedTo: "Priya Sharma",
    assignedToId: "priya",
    dueDate: "08 May 2026",
    recordType: "Task",
    estimatedHours: 10,
    isProjectManager: true,
    comments: [],
  },
];

export const leaveBalances = [
  { id: "casual", label: "Casual Leave", used: 18.5, total: 24 },
  { id: "sick", label: "Sick Leave", used: 8, total: 12 },
  { id: "earned", label: "Earned Leave", used: 15, total: 18 },
];

export const holidays = [
  { date: "26 May 2025", name: "Buddha Purnima" },
  { date: "06 Jun 2025", name: "Eid-ul-Adha" },
  { date: "15 Aug 2025", name: "Independence Day" },
];

export const initialLeaveRequests = [
  { id: "lr1", date: "16 May 2025", duration: "Half Day", status: "Approved" },
  { id: "lr2", date: "02 Jun 2025", duration: "1 Day", status: "Pending" },
  { id: "lr3", date: "10 Jun 2025", duration: "2 Days", status: "Pending" },
];

export const payroll = {
  title: "May 2025 Salary Slip",
  status: "Paid",
  takeHome: "₹1,24,500",
  payDate: "31 May 2025",
  rows: [
    { label: "Gross Salary", value: "₹1,80,000" },
    { label: "Deductions", value: "₹55,500" },
    { label: "Tax (TDS)", value: "₹24,000" },
    { label: "Net Pay", value: "₹1,24,500" },
  ],
};

export const policies = [
  { id: "leave", title: "Leave Policy", date: "01 Jan 2025", icon: FiFileText, tone: "green" },
  { id: "travel", title: "Travel Policy", date: "15 Feb 2025", icon: FiActivity, tone: "blue" },
  { id: "work-location", title: "Work Location Policy", date: "10 Mar 2025", icon: FiHome, tone: "purple" },
  { id: "conduct", title: "Code of Conduct", date: "01 Jan 2025", icon: FiShield, tone: "orange" },
];

export const onboardingTasks = [
  { id: "profile", label: "Complete employee profile", done: true },
  { id: "benefits", label: "Review benefits enrollment", done: true },
  { id: "security", label: "Finish security training", done: true },
  { id: "equipment", label: "Confirm equipment checklist", done: false },
  { id: "buddy", label: "Meet assigned buddy", done: false },
];

export const birthdays = [
  { id: "ravi", name: "Ravi Sharma", date: "22 May", initials: "RS" },
  { id: "neha", name: "Neha Kapoor", date: "24 May", initials: "NK" },
];

export const quickActions = [
  { id: "leave", label: "Request Leave", icon: FiCalendar, tone: "blue" },
  { id: "time", label: "Log Time", icon: FiClock, tone: "indigo" },
  { id: "expense", label: "Add Expense", icon: FiFileText, tone: "green" },
  { id: "hr", label: "New Request", icon: FiFileText, tone: "purple" },
];

export const employeeProfile = {
  summary: {
    employeeId: "ANZ-0246",
    department: "Design",
    location: "Bengaluru, India",
    joinedOn: "12 Aug 2023",
    completeness: "100%",
  },
  personal: [
    { label: "Legal Name", value: "Priya Sharma" },
    { label: "Preferred Name", value: "Priya" },
    { label: "Date of Birth", value: "18 Feb 1996" },
    { label: "Blood Group", value: "B+" },
    { label: "Gender", value: "Female" },
    { label: "Nationality", value: "Indian" },
  ],
  contact: [
    { label: "Work Email", value: "priya@antrazal.com" },
    { label: "Mobile", value: "+91 98765 43210" },
    { label: "Personal Email", value: "priya.personal@example.com" },
    { label: "LinkedIn Profile", value: "https://www.linkedin.com/in/priya-sharma" },
    { label: "Trailblazer Profile", value: "https://www.salesforce.com/trailblazer/priyasharma" },
  ],
  employment: [
    { label: "Designation", value: "Product Designer" },
    { label: "Manager", value: "Arjun Mehta" },
    { label: "Employment Type", value: "Full Time" },
    { label: "Work Location", value: "Bengaluru, India" },
    { label: "Shift", value: "General" },
    { label: "Cost Center", value: "Design Studio" },
  ],
  addresses: [
    {
      type: "Mailing Address",
      line1: "Tower 8, Indiranagar",
      city: "Bengaluru",
      state: "Karnataka",
      country: "India",
      zipCode: "560038",
    },
    {
      type: "Current Living Address",
      line1: "Civil Lines",
      city: "Jaipur",
      state: "Rajasthan",
      country: "India",
      zipCode: "302006",
    },
  ],
  emergencyContacts: [
    {
      name: "Amit Sharma",
      relationship: "Spouse",
      phone: "+91 98111 24567",
      email: "amit.sharma@example.com",
    },
    {
      name: "Kavita Sharma",
      relationship: "Mother",
      phone: "+91 98222 34567",
      email: "kavita.sharma@example.com",
    },
  ],
  insuranceDependents: [
    {
      id: "dep-amit",
      name: "Amit Sharma",
      relationship: "Spouse",
      dateOfBirth: "1992-04-12",
      coverage: "Health Insurance",
      nominee: "Yes",
    },
    {
      id: "dep-kavita",
      name: "Kavita Sharma",
      relationship: "Mother",
      dateOfBirth: "1968-09-20",
      coverage: "Health Insurance",
      nominee: "No",
    },
  ],
  bankAccounts: [
    {
      id: "bank-salary",
      bankName: "HDFC Bank",
      accountHolder: "Priya Sharma",
      accountNumber: "**** 4582",
      ifsc: "HDFC0001234",
      accountType: "Salary",
      status: "Primary",
    },
  ],
  payrollIdentifiers: [
    { label: "PAN", value: "ABCDE1234F" },
    { label: "UAN", value: "1002 3456 7890" },
    { label: "Bank Account", value: "HDFC Bank · **** 4582" },
    { label: "IFSC", value: "HDFC0001234" },
  ],
  documents: [
    { label: "Aadhaar", status: "Verified", updated: "14 Aug 2023" },
    { label: "PAN", status: "Verified", updated: "14 Aug 2023" },
    { label: "Address Proof", status: "Needs Review", updated: "02 May 2025" },
    { label: "Education Certificate", status: "Verified", updated: "18 Aug 2023" },
  ],
};

export const directory = [
  { id: "priya", name: "Priya Sharma", role: "Product Designer", team: "Design" },
  { id: "arjun", name: "Arjun Mehta", role: "VP of Engineering", team: "Engineering" },
  { id: "neha", name: "Neha Kapoor", role: "UX Lead", team: "Design" },
  { id: "ravi", name: "Ravi Sharma", role: "Delivery Manager", team: "Operations" },
];

export const expenseClaims = [];

export const allocatedAssets = [
  {
    id: "asset-macbook",
    assetTag: "ANZ-LPT-0246",
    name: "MacBook Pro 14",
    category: "Laptop",
    serialNumber: "C02ZQ1ABMD6T",
    assignedTo: "Priya Sharma",
    assignedOn: "14 Aug 2023",
    condition: "Good",
    returnDue: "On exit",
    status: "Assigned",
  },
  {
    id: "asset-monitor",
    assetTag: "ANZ-MON-0188",
    name: "Dell UltraSharp 27",
    category: "Monitor",
    serialNumber: "DL27-88A21",
    assignedTo: "Priya Sharma",
    assignedOn: "18 Aug 2023",
    condition: "Good",
    returnDue: "On exit",
    status: "Assigned",
  },
  {
    id: "asset-headset",
    assetTag: "ANZ-AUD-0412",
    name: "Jabra Evolve2",
    category: "Audio",
    serialNumber: "JB-412-29",
    assignedTo: "Priya Sharma",
    assignedOn: "20 Aug 2023",
    condition: "Working",
    returnDue: "On exit",
    status: "Assigned",
  },
  {
    id: "asset-token",
    assetTag: "ANZ-SEC-0064",
    name: "Security Key",
    category: "Security",
    serialNumber: "YK-64-246",
    assignedTo: "Priya Sharma",
    assignedOn: "21 Aug 2023",
    condition: "Working",
    returnDue: "Immediate on request",
    status: "Assigned",
  },
];

export const benefitPlans = [
  { id: "health", title: "Health Insurance", value: "Family Cover", detail: "Active through Mar 2026", status: "Active" },
  { id: "wellness", title: "Wellness Allowance", value: "₹18,000", detail: "₹6,000 remaining", status: "Available" },
  { id: "learning", title: "Learning Budget", value: "₹45,000", detail: "₹28,000 remaining", status: "Available" },
  { id: "retirement", title: "Retirement Plan", value: "12% Match", detail: "Next review in July", status: "Active" },
];

export const performanceGoals = [
  { id: "research", title: "Improve discovery quality", owner: "Priya Sharma", progress: 72, dueDate: "30 Jun 2025" },
  { id: "system", title: "Design system adoption", owner: "Priya Sharma", progress: 64, dueDate: "15 Jul 2025" },
  { id: "mentoring", title: "Mentor associate designers", owner: "Priya Sharma", progress: 86, dueDate: "31 Aug 2025" },
];

export const learningCourses = [
  { id: "ai", title: "AI for Product Teams", provider: "Antrazal Academy", progress: 58, duration: "4h 20m" },
  { id: "security", title: "Secure Design Practices", provider: "Security Office", progress: 100, duration: "1h 10m" },
  { id: "leadership", title: "Stakeholder Communication", provider: "People Team", progress: 30, duration: "3h 45m" },
];

export const salesforceRequests = [
  {
    id: "request1",
    requestNumber: "REQ-00014521",
    subject: "Laptop battery replacement",
    priority: "Medium",
    status: "Open",
    requestType: "IT Support",
    updated: "Today",
  },
  {
    id: "request2",
    requestNumber: "REQ-00014509",
    subject: "Figma license renewal",
    priority: "High",
    status: "In Review",
    requestType: "Access Request",
    updated: "Yesterday",
  },
  {
    id: "request3",
    requestNumber: "REQ-00014488",
    subject: "Payroll tax document request",
    priority: "Low",
    status: "Resolved",
    requestType: "HR Support",
    updated: "16 May 2025",
  },
];

export const payrollHistory = [
  { id: "2025-05", period: "May 2025", payDate: "31 May 2025", gross: "₹1,80,000", deductions: "₹55,500", tax: "₹24,000", net: "₹1,24,500", status: "Paid" },
  { id: "2025-04", period: "Apr 2025", payDate: "30 Apr 2025", gross: "₹1,80,000", deductions: "₹55,500", tax: "₹24,000", net: "₹1,24,500", status: "Paid" },
  { id: "2025-03", period: "Mar 2025", payDate: "31 Mar 2025", gross: "₹1,72,000", deductions: "₹51,800", tax: "₹22,600", net: "₹1,20,200", status: "Paid" },
  { id: "2025-02", period: "Feb 2025", payDate: "28 Feb 2025", gross: "₹1,72,000", deductions: "₹51,800", tax: "₹22,600", net: "₹1,20,200", status: "Paid" },
  { id: "2025-01", period: "Jan 2025", payDate: "31 Jan 2025", gross: "₹1,72,000", deductions: "₹51,800", tax: "₹22,600", net: "₹1,20,200", status: "Paid" },
  { id: "2024-12", period: "Dec 2024", payDate: "31 Dec 2024", gross: "₹1,68,000", deductions: "₹49,900", tax: "₹21,400", net: "₹1,18,100", status: "Paid" },
  { id: "2024-11", period: "Nov 2024", payDate: "30 Nov 2024", gross: "₹1,68,000", deductions: "₹49,900", tax: "₹21,400", net: "₹1,18,100", status: "Paid" },
  { id: "2024-10", period: "Oct 2024", payDate: "31 Oct 2024", gross: "₹1,68,000", deductions: "₹49,900", tax: "₹21,400", net: "₹1,18,100", status: "Paid" },
  { id: "2024-09", period: "Sep 2024", payDate: "30 Sep 2024", gross: "₹1,65,000", deductions: "₹48,600", tax: "₹20,800", net: "₹1,16,400", status: "Paid" },
  { id: "2024-08", period: "Aug 2024", payDate: "31 Aug 2024", gross: "₹1,65,000", deductions: "₹48,600", tax: "₹20,800", net: "₹1,16,400", status: "Paid" },
  { id: "2024-07", period: "Jul 2024", payDate: "31 Jul 2024", gross: "₹1,65,000", deductions: "₹48,600", tax: "₹20,800", net: "₹1,16,400", status: "Paid" },
  { id: "2024-06", period: "Jun 2024", payDate: "30 Jun 2024", gross: "₹1,58,000", deductions: "₹45,700", tax: "₹19,500", net: "₹1,12,300", status: "Paid" },
  { id: "2024-05", period: "May 2024", payDate: "31 May 2024", gross: "₹1,58,000", deductions: "₹45,700", tax: "₹19,500", net: "₹1,12,300", status: "Paid" },
  { id: "2024-04", period: "Apr 2024", payDate: "30 Apr 2024", gross: "₹1,58,000", deductions: "₹45,700", tax: "₹19,500", net: "₹1,12,300", status: "Paid" },
];

export const actionCatalog = {
  leave: {
    title: "Request Leave",
    description: "Create a frontend-only leave request for review.",
  },
  time: {
    title: "Log Time",
    description: "Weekly work log",
  },
  timeEntry: {
    title: "Time Entry",
    description: "Review and update the selected day.",
  },
  bulkTime: {
    title: "Fill Selected",
    description: "Apply one time entry to every selected date.",
  },
  expense: {
    title: "Add Expense",
    description: "Save a local expense draft.",
  },
  hr: {
    title: "New Request",
    description: "Create a Salesforce-backed request draft.",
  },
  attendanceRequest: {
    title: "Attendance Case",
    description: "Raise a Salesforce-backed Leave & Attendance case.",
  },
  assetRequest: {
    title: "Asset Request",
    description: "Create a Salesforce-backed asset request.",
  },
  financeRequest: {
    title: "Finance Case",
    description: "Create a Salesforce-backed payroll or finance case.",
  },
  payslip: {
    title: "Salary Slip",
    description: "View or download the selected salary slip.",
  },
  directory: {
    title: "Company Directory",
    description: "Browse team members.",
  },
  quick: {
    title: "Quick Action",
    description: "Choose a frontend action to run.",
  },
  timesheet: {
    title: "Timesheet",
    description: "Review the month timesheet.",
  },
  policies: {
    title: "All Policies",
    description: "Review available policy documents.",
  },
  policyDetail: {
    title: "Policy Details",
    description: "Review selected policy details.",
  },
  onboarding: {
    title: "Onboarding Tasks",
    description: "Update frontend-only onboarding tasks.",
  },
  profile: {
    title: "My Profile",
    description: "Review saved employee profile details.",
  },
};
